'use client';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { type ProgressBar } from '@/services/funnelService/types';

const getCurrentStepPct = (progressBar: ProgressBar) => {
  const {
    currentSlug,
    progress: { steps },
  } = progressBar;

  const currentStep = steps.find((step) => step.slug === currentSlug);

  if (!currentStep) {
    return null;
  }

  return currentStep.pct;
};

const getSectionByPct = (pct: number, progressBar: ProgressBar) => {
  const {
    progress: { sections },
  } = progressBar;

  for (let index = 0; index < sections.length; index += 1) {
    const section = sections[index];

    if (pct >= section.fromPct && pct <= section.toPct) {
      return section;
    }
  }

  return null;
};

const ProgressBar = ({ progressBar }: { progressBar: ProgressBar }) => {
  const currentStepPct = getCurrentStepPct(progressBar);

  if (!currentStepPct) {
    return null;
  }

  const section = getSectionByPct(currentStepPct, progressBar);

  if (!section) {
    return null;
  }

  const {
    progress: { gaps },
  } = progressBar;

  return (
    <div>
      <div className="cur-mb-2 cur-text-center">
        <Typography weight="bold">{section.name}</Typography>
      </div>
      <div className="cur-mt-2 cur-relative">
        <div className="cur-bg-curology-secondary-50 cur-h-[6px] cur-overflow-hidden cur-rounded-[3px]">
          <div
            className="cur-bg-curology-brand-500 cur-h-[6px] cur-transition-all"
            style={{ width: `${currentStepPct}%` }}
          ></div>
          {gaps.map((gap, index) => {
            return (
              <div
                className="cur-absolute cur-bg-[#FFFFFF] cur-h-[6px] cur-top-0"
                key={index}
                style={{
                  left: `${gap.fromPct}%`,
                  width: `${gap.toPct - gap.fromPct}%`,
                }}
              ></div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
